import React from 'react';
import styled from 'styled-components';
import ProjectWorkflowContainer from './ProjectWorkflowContainer';

const Container = styled.div`
    width:100%;
    min-height:100%;
    padding:0;

`;

class GbuFunctionDetails
 extends React.Component{


    render(){

        return (
                <Container>
                    <ProjectWorkflowContainer/>
                </Container>

        );

    }

}

export default GbuFunctionDetails;